"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: {
    network: Object
  },
  data() {
    return {
      new_nick: '',
      error_message: '',
      event_listeners: [],
      self_user_settings_open: false
    };
  },
  computed: {
    user() {
      return this.network.currentUser();
    },
    modeString() {
      const user = this.user;
      if (!user.modes.length) {
        return '';
      }
      return user.modes.reduce((acc, item) => acc + item.mode, '+');
    },
    awayStatus: {
      get() {
        return this.user.away;
      },
      set(val) {
        this.network.ircClient.raw('AWAY', val ? 'Currently away' : '');
      }
    }
  },
  methods: {
    openSelfActions() {
      this.self_user_settings_open = true;
      this.error_message = '';
    },
    openProfile() {
      this.$state.$emit('userbox.show', this.user);
    },
    closeSelfUser() {
      this.$emit('close');
    },
    onNewNickSubmit(newVal, done) {
      if (this.event_listeners.length) {
        // nick change already in progress
        return;
      }
      this.new_nick = newVal;
      this.changeNick(done);
    },
    changeNick(done) {
      let nick = this.new_nick.trim();
      if (nick.length === 0) {
        this.error_message = TextFormatting.t('error_empty_nick');
        done();
        return;
      }
      if (nick.match(/(^[0-9])|(\s)/)) {
        this.error_message = TextFormatting.t('error_no_number');
        done();
        return;
      }
      if (nick === this.user.nick) {
        this.error_message = TextFormatting.t('error_nick_in_use', {
          nick
        });
        done();
        return;
      }
      this.error_message = '';
      this.listenForNickEvents(done);
      this.network.ircClient.changeNick(nick);
    },
    listenForNickEvents(done) {
      this.event_listeners.push(this.listen(this.network.ircClient, 'nick', event => {
        if (event.new_nick !== this.user.nick) {
          return;
        }
        this.closeNickChange();
      }));
      this.event_listeners.push(this.listen(this.network.ircClient, 'nick in use', event => {
        this.error_message = TextFormatting.t('error_nick_in_use', {
          nick: event.nick
        });
        this.removeNickEventListeners();
        done();
      }));
      this.event_listeners.push(this.listen(this.network.ircClient, 'nick invalid', event => {
        this.error_message = TextFormatting.t('error_nick_invalid', {
          nick: event.nick
        });
        this.removeNickEventListeners();
        done();
      }));

      // Maybe the nickchange will result in an event we are not listening for above
      const timeout = this.setTimeout(() => {
        this.error_message = TextFormatting.t('error_unexpected');
        this.removeNickEventListeners();
      }, 4000);
      this.event_listeners.push(() => {
        this.clearTimeout(timeout);
      });
    },
    removeNickEventListeners() {
      while (this.event_listeners.length) {
        this.event_listeners.shift()();
      }
    },
    closeNickChange() {
      this.removeNickEventListeners();
      this.self_user_settings_open = false;
    },
    networkSupportsAway() {
      return this.network.ircClient.network.cap.isEnabled('away-notify');
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SelfUser"]
window._kiwi_exports.components.SelfUser = exports.default ? exports.default : exports;
